import styled, { keyframes } from 'styled-components'

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
`

export const Loader = styled.div`
	border: 0.2em solid rgba(0, 0, 0, 0.3);
	border-top: 0.2em solid
		${(props) => (props.color ? props.color : 'var(--btn-color)')};
	border-radius: 50%;
	width: 2.28571429rem;
	height: 2.28571429rem;
	animation: ${spin} 0.9s linear infinite;
	display: flex;
	position: absolute;
	left: 44%;
	height: 1.2em;
	width: 1.2em;
	top: 10%;
`
